import React, { Suspense } from 'react'
import { hot } from 'react-hot-loader'
import { Provider } from 'react-redux'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import { authProvider } from './services/authProvider'
import store, { history } from './store/configureStore'
import './global.css'
import Layout from './components/Shared/LayoutComponents/Layout'
import LayoutLoading from './components/Shared/LayoutComponents/LayoutLoading'

import Companies from './components/Companies/Companies'
import CreateCompanySelect from './components/CreateCompany/CreateCompanySelect'
import CreateCompanyDetails from './components/CreateCompany/CreateCompanyDetails'
import CompanyDetails from './components/CompanyDetails/CompanyDetails'
import Dashboard from './components/Dashboard/Dashboard'
import Login from './components/Login/Login'
import NotFound from './components/NotFound/NotFound'
import SelectAgreement from './components/CreateCompany/SelectAgreement'
import Approvals from './components/Approvals/Approvals'
import Reconciliation from './components/Sales/Reconciliation'
import EssentialsReconciliation from './components/Sales/EssentialsReconciliation'
import ReconCompany from './components/Sales/ReconCompany'
import ReconDetails from './components/Sales/Details/ReconDetails'
import ReUpload from './components/Sales/ReUpload/ReUpload'
import ProductMapping from './components/ProductMapping/ProductMapping'
import UnsyncedCompanies from './components/Unsynced/UnsyncedCompanies'
import Reports from './components/Reports/Reports'
import Backup365Reports from './components/365BackupReport/Backup365Reports'
import EmailReport from './components/EmailReport/EmailReport'
import CreateEmailReport from './components/EmailReport/CreateEmailReport'
import KeeperRecon from './components/Sales/KeeperRecon/KeeperRecon'
import ThreatlockerRecon from './components/ThreatlockerRecon/ThreatlockerRecon'

function App() {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState }) => {
        return (
          <Provider store={store}>
            <ConnectedRouter history={history}>
              <Suspense fallback={<LayoutLoading />}>
                {authenticationState === AuthenticationState.Authenticated ? (
                  <Layout className="root">
                    <Switch>
                      <Route exact path="/" component={Dashboard} />
                      <Route component={CompanyDetails} path="/Companies/:companyId/Details" />
                      <Route component={Companies} path="/Companies" exact />
                      <Route component={Approvals} path="/Approvals" />
                      <Route component={UnsyncedCompanies} path="/unsynced" />
                      <Route component={CreateCompanySelect} exact path="/Create" />
                      <Route component={CreateCompanyDetails} path="/Create/Details" />
                      <Route component={SelectAgreement} path="/Create/Agreement" />
                      <Route component={Reconciliation} path="/Reconciliation" exact />
                      <Route component={EssentialsReconciliation} path="/EssentialsReconciliation" exact />
                      <Route component={ReUpload} path="/Reconciliation/ReUpload" />
                      <Route component={ReconDetails} path="/Reconciliation/:companyId/Details/:reconId" />
                      <Route component={ReconCompany} path="/Reconciliation/:companyId/List" />
                      <Route component={ProductMapping} path="/ProductMapping" />
                      <Route component={Reports} path="/Reports" />
                      <Route component={Backup365Reports} path="/365BackupReport" /> 
                      <Route component={EmailReport} path="/EmailReport" exact />
                      <Route component={CreateEmailReport} path="/EmailReport/Create" />
                      <Route component={KeeperRecon} path="/KeeperRecon" exact />
                      <Route component={ThreatlockerRecon} path="/ThreatlockerRecon" />
                      <Route component={NotFound} />
                    </Switch>
                  </Layout>
                ) : (
                  <Route exact path="/" component={Login} />
                )}
              </Suspense>
            </ConnectedRouter>
          </Provider>
        )
      }}
    </AzureAD>
  )
}

export default hot(module)(App)
